import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import {
  Box,
  Container
} from '@material-ui/core';
import ProductListToolbar from 'src/components/provider/ProviderForm';
import {  useParams } from 'react-router-dom';

const ProductList = () => {
  const {id} = useParams();
  
  return (
    <>
      <Helmet>
        <title>Providers</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <ProductListToolbar id={id}/>
        </Container>
      </Box>
    </>
  )
};

export default ProductList;
